import classNames from "classnames";
import React, { useState } from "react";

import styles from "./index.module.scss";
import { Selector } from "../inputSelector";

interface Props<T> {
  options: Array<T>;
  onItemClick: (value: T) => void;
  renderLabel: (value: T) => string;
  isMultiSelect?: boolean;
  isSelected?: (value: T) => boolean;
  status: string;
  isDisabled?: boolean;
}

export default function ReactiveList<T>(props: Props<T>) {
  const {
    options,
    renderLabel,
    onItemClick,
    isMultiSelect = false,
    isSelected = () => true,
    status,
    isDisabled,
  } = props;
  const [highlightedItem, setHighLightedItem] = useState(0);

  return (
    <div
      className={classNames(styles.list, {
        [styles.on]: status === "entered",
        [styles.off]: status !== "entered",
      })}
    >
      {options.map((item, index) => (
        <div
          className={classNames(
            styles.item,
            isDisabled && !isSelected(item)
              ? styles.disabled
              : highlightedItem === index && styles.active,
          )}
          key={index}
          // TODO:this is a workaround for both type ahead and multiselect
          onMouseDown={() => {
            if (!isMultiSelect && !isDisabled) {
              onItemClick(item);
            }
          }}
          onMouseEnter={() => setHighLightedItem(index)}
          onClick={(e) => {
            e.preventDefault();
            if (!isDisabled || (isDisabled && isSelected(item))) {
              onItemClick(item);
            }
          }}
        >
          {isMultiSelect ? (
            <Selector
              label={renderLabel(item)}
              checked={isSelected(item)}
              labelClassname={classNames(
                styles.multiselectText,
                highlightedItem === index && styles.active,
              )}
              checkboxClassname={classNames(
                styles.multiselectBox,
                highlightedItem === index && styles.active,
              )}
            />
          ) : (
            renderLabel(item)
          )}
        </div>
      ))}
    </div>
  );
}
